import React from "react";
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { t } from "../../../lang/index";

const ChooseUsSection = () => {
  const cards = t("chooseUsSection.cards"); // retorna array de cards

  return (
    <section className="section choose-us-section">
      <div className="container">
        <div className="choose-title">
          <h2>{t("chooseUsSection.title")}</h2>
        </div>
        <div className="row g-4">
          {cards.map((card: any, index: number) => (
            <div key={index} className="col-lg-3">
              <div className="choose-card">
                <div className="choose-icon mb-3">
                  <span className="rounded-circle d-flex align-items-center justify-content-center">
                    <i className={`isax ${
                      ["isax-archive-tick","isax-dollar-square","isax-headphone","isax-map"][index]
                    } text-white`} />
                  </span>
                </div>
                <div className="card-content">
                  <h6 className="mb-2">{card.title}</h6>
                  <p className="fs-16 text-gray-6">{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Background Images */}
        <div className="choose-bg-01">
          <ImageWithBasePath src="assets/img/bg/about-bg-stars-bottom.png" alt="image" className="img-fluid" />
        </div>
        <div className="choose-bg-01">
          <ImageWithBasePath src="assets/img/bg/about-bg-stars-bottom.png" alt="image" className="img-fluid" />
        </div>
        <div className="choose-bg-02">
          <ImageWithBasePath src="assets/img/bg/about-bg-stars-top.png" alt="image" className="img-fluid" />
        </div>
      </div>
    </section>
  );
};

export default ChooseUsSection;
